import {
  type AiConfig,
  type AiConfigTag,
  isRagProfile,
  type RagProfileConfig,
  type RagSettings,
  type StaticProfileConfig,
} from '@lokalise/translation-api-schemas'

export type CreationConfigAllowedTypes = Exclude<AiConfigTag, 'tm'>

export type UserCreatedConfig = RagSettings & { type: CreationConfigAllowedTypes }

export type UserCreatedProfile = RagProfileConfig & {
  config: { rag: UserCreatedConfig }
}

export const isStaticProfile = (profile: AiConfig): profile is StaticProfileConfig =>
  profile.is_static && !profile.config.rag

export const isPredefinedProfile = (profile: AiConfig): profile is RagProfileConfig =>
  isRagProfile(profile) && profile.config?.rag?.type === 'tm'

export const isUserCreatedProfile = (profile: AiConfig): profile is UserCreatedProfile => {
  return profile.is_static === false && !isPredefinedProfile(profile)
}
